import React, { useState } from "react";
import { Modal } from "reactstrap";
import DisplayError from "../../common/DisplayError";
import NnLeaseGdpr from "../../documents/nnlease-gdpr/NNLeaseGDPR";
import NNLeaseIntermediation from "../../documents/nnlease-intermediation/NNLeaseIntermediation";
import NNLeaseMarketing from "../../documents/nnlease-marketing/NNLeaseMarketing";
import "../CheckAgreementField/CheckAgreementField.css";
import "./DocumentAgreement.css";
import type { BaseFieldProps } from "../types";
import { useFormContext } from "react-hook-form";

const DocumentAgreement: React.FC<BaseFieldProps> = (props) => {
  const [modal, setModal] = useState(false);
  const { field } = props;
  const form = useFormContext();
  const { setValue, getValues, formState: { errors } } = form;
  const error = errors[field.name];

  let classes = "checkmark";
  if (props.error) {
    classes = classes + " error";
  }

  const handleClick = () => setModal(!modal);

  const handleChange = (value: boolean) => {
    setValue(field.name, value);
  };

  const noChange = (ev: React.ChangeEvent<HTMLInputElement>) => {
    ev.persist();
  };

  const getAgreementDocument = () => {
    const docProps = {
      toggle: handleClick,
      setAgreementValue: handleChange,
      agreementValue: getValues(field.name),
    };
    switch (field.name) {
      case "gdprAgreement":
        return <NnLeaseGdpr {...docProps} />;
      case "marketingAgreement":
        return <NNLeaseMarketing {...docProps} />;
      case "procureAgreement":
        return <NNLeaseIntermediation {...docProps} />;
      default:
        return null;
    }
  };

  return (
    <div>
      <div className="checkbox-container checkbox-warning-filled mb-2 pr-4">
        <div className="d-inline-block" onClick={handleClick}>
          <label className="form-check-label checkbox-label d-inline-block">
            <input
              type="checkbox"
              id={field.name}
              name={field.name}
              className={"form-check-input"}
              checked={
                getValues(field.name)
                  ? getValues(field.name)
                  : false
              }
              value={
                getValues(field.name)
                  ? getValues(field.name)
                  : false
              }
              onChange={noChange}
              disabled={true}
            />
            <span className={classes}></span>
          </label>
          <div className="field-label d-inline-block cursor-pointer">
            {field.label}
          </div>
        </div>
        <DisplayError
          errorCondition={error}
          errorMessage={error?.message as string}
        />
      </div>
      <Modal
        size="lg"
        isOpen={modal}
        toggle={handleClick}
        className="modal-width"
        backdrop={getValues(field.name) ? true : "static"}
        keyboard={getValues(field.name) ? true : false}
      >
        {getAgreementDocument()}
      </Modal>
    </div>
  );
};

export default DocumentAgreement;
